<template>
    <div>
        <slot :loading="isPolling" :data="data"></slot>
    </div>
</template>
<script>
export default {
    props: {
        url: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            interval: null,
            isPolling: true,
            data: null,
        };
    },
    mounted() {
        this.startPolling();
    },
    methods: {
        startPolling() {
            this.interval = setInterval(() => {
                this.retrieveData();
            }, 5000);
        },
        stopPolling() {
            clearInterval(this.interval);
        },
        retrieveData() {
            this.stopPolling();
            axios.get(this.url)
                .then(({data}) => {
                    if (!data.complete) {
                        this.startPolling();
                        return;
                    }

                    if(data.redirect) {
                        window.location.href = data.redirect;
                    }

                    this.data = data;
                    this.isPolling = false;
                })
                .catch(({response}) => {
                    window.location.href = response.data.redirect;
                });
        }
    }
}
</script>
